import React, { Component } from "react";
import ModalContainer from "../../modal/ModalContainer";
import { inject } from "mobx-react";
import moment from 'moment'

import { withRouter } from "react-router-dom";

import { DialogContent, IconButton } from "@material-ui/core";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import AssignmentIcon from "@material-ui/icons/Assignment";
import CloseIcon from "@material-ui/icons/Close";

import "./BookingOptionModal.css";

@withRouter
@inject("searchStore")
class BookingOptionModal extends Component {

    handleNormalBooking = () => {
        const { requiredDate } = this.props.searchStore;
        const { actId } = this.props;
        let date = moment();
        if(requiredDate)
        {
            date = requiredDate;
        }


        this.props.history.push(`/booking/new?dateStart=${moment(date).format("DD-MM-YYYY")}&dateEnd=${moment(date).format("DD-MM-YYYY")}&actId=${actId}&forceAct=true`);
    }

    handleAdhocBooking = () => {
        const { requiredDate } = this.props.searchStore;
        const { actId } = this.props;
        let date = moment();
        if(requiredDate)
        {
            date = requiredDate;
        }

        this.props.history.push(`/privateBooking?date=${moment(date).format("DD-MM-YYYY")}&act=${actId}&forceAct=true`);
    }

    render() {
        const { unShowPrivate } = this.props;

        return (
            <ModalContainer open={this.props.open} onClose={this.props.onClose} fullScreen={false} maxWidth="sm">
                <DialogContent className="booking-modal-content">
                    <IconButton className="booking-modal-close" onClick={this.props.onClose}>
                        <CloseIcon />
                    </IconButton>
                    
                    <div className="booking-modal-header">
                        <h2>Create New Booking</h2>
                        <p>Select the type of booking you want to create</p>
                    </div>

                    <div className="booking-options-container">
                        {!unShowPrivate && (
                            <div className="booking-option-card" onClick={this.handleAdhocBooking} role="button" tabIndex={0} onKeyPress={(e) => e.key === 'Enter' && this.handleAdhocBooking()}>
                                <div className="booking-option-icon">
                                    <AssignmentIcon />
                                </div>
                                <h3 className="booking-option-title">Private/Corporate Event</h3>
                                <p className="booking-option-description">Create a private or corporate event booking</p>
                            </div>
                        )}

                        <div className="booking-option-card" onClick={this.handleNormalBooking} role="button" tabIndex={0} onKeyPress={(e) => e.key === 'Enter' && this.handleNormalBooking()}>
                            <div className="booking-option-icon">
                                <LocationOnIcon />
                            </div>
                            <h3 className="booking-option-title">Venue Booking</h3>
                            <p className="booking-option-description">Book entertainment for a specific venue location</p>
                        </div>
                    </div>
                </DialogContent>
            </ModalContainer>
        );
    }
}

export default BookingOptionModal;
